// eslint-disable-next-line camelcase
import { RCC_Get, RCC_Post, RCC_Put } from '@/utils/axios'

// 登录接口
export const LoginServer = (param = {}) => RCC_Post('/sys/loginForIot', param)

export const MenuListServer = (param = {}) => RCC_Get('/MenuList', param)

// 退出登录
export const LoginOut = (param = {}) => RCC_Get('/sys/logout', param)

// 修改密码
export const UpdatePassword = (param = {}) => RCC_Put('/sys/user/updatePassword', param)
